import React from 'react'

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-white py-16 px-6">
      <div className="max-w-6xl mx-auto">
        <h1 className="text-4xl font-bold text-slate-900 mb-8">Privacy Policy</h1>
        <div className="prose prose-slate max-w-none">
          {/* <p className="text-lg text-slate-600 mb-6">Last updated: {new Date().toLocaleDateString()}</p> */}

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-slate-900 mb-4">Our Commitment</h2>
            <p className="text-slate-600 mb-4">Tutor Match AE respects your privacy and is committed to protecting your personal information.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-slate-900 mb-4">Information We Collect</h2>
            <p className="text-slate-600 mb-4">We collect information you provide when you create an account, contact us, or use the
              platform.</p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-slate-900 mb-4">How We Use Information</h2>
            <p className="text-slate-600 mb-4">Your information is used to operate the platform, manage accounts and bookings, process
              payments, communicate with you, and provide support.</p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-slate-900 mb-4">Information Sharing</h2>
            <p className="text-slate-600 mb-4">We do not sell personal information. Information may be shared only where necessary to
              operate the platform or where required by law.</p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-slate-900 mb-4">Data Protection</h2>
            <p className="text-slate-600 mb-4">We take reasonable steps to protect personal information using appropriate security
              measures.</p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-slate-900 mb-4">Contact Us</h2>
            <p className="text-slate-600">If you have questions about this Privacy Policy, you can contact us directly.</p>
          </section>
        </div>
      </div>
    </div>
  )
}

export default PrivacyPolicy;